<template>
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
  >
    <path d="M0.206944 7.26716C-0.0787472 6.96724 -0.0672107 6.4925 0.232712 6.20681L5.48318 1.20548C5.77285 0.929554 6.22809 0.929554 6.51776 1.20548L11.7682 6.20681C12.0681 6.4925 12.0797 6.96724 11.794 7.26716C11.5083 7.56708 11.0336 7.57862 10.7336 7.29293L6.00047 2.78434L1.26729 7.29293C0.967369 7.57862 0.492635 7.56708 0.206944 7.26716Z" />
  </svg>
</template>
